import { FC } from 'react';

import { useMutation, useQueryClient } from 'react-query';
import { useForm, Controller } from 'react-hook-form';

import { IconButton, DialogTitle, DialogContent, TextField } from '@mui/material';
import Button from '@mui/lab/LoadingButton';
import CloseIcon from '@mui/icons-material/Close';
import { createMark } from 'api/marks';

type Props = {
    /**
     * Функция закрытия диалогового окна.
     */
    close: () => void;
}

/**
 * Диалоговое окно для создания метки.
 */
const MarksDialog: FC<Props> = ({ ...props }) => {
    const queryClient = useQueryClient();

    const { control, handleSubmit } = useForm({
        defaultValues: {
            name: '',
        },
    });

    const newItemMutation = useMutation(createMark, {
        onSuccess: () => {
            queryClient.invalidateQueries('marks-data');
            queryClient.invalidateQueries('tournaments-marks-data');

            props.close();
        },
    });


    /**
     * Функция сохранения формы.
     */
    const onSubmit = handleSubmit(data => {
        newItemMutation.mutate(data);
    });

    return (
        <>
            <DialogTitle>
                Новая метка
                <IconButton
                    aria-label='close'
                    onClick={() => {
                        props.close();
                    }}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <form className='flex flex-col gap-4 pt-2' onSubmit={onSubmit}>
                    <Controller
                        control={control}
                        name='name'
                        render={({ field }) => <TextField {...field} label='Название метки' fullWidth />}
                    />
                    
                    <div className='pt-4'>
                        <Button
                            fullWidth
                            variant='contained'
                            size='large'
                            type='submit'
                            loading={newItemMutation.isLoading}
                        >
                            Добавить
                        </Button>
                    </div>
                </form>
            </DialogContent>
        </>
    );
};

export default MarksDialog;
